module.exports = __webpack_public_path__ + "img/tabaco.63b44838.svg";